module.exports = __webpack_public_path__ + "media/images/bsmart/icons/check-4b94b2373055bc972ea16b239a1105cd.svg";